/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './SupportLink.style';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';
import LinkWithChevron from 'src/shared/ui/component/link/LinkWithChevron';

type Props = {
  title: string,
  cta: string,
  href: string,
  icon: React.Node,
  handleClick: () => void,
};

const useStyles = createUseStyles(styles);

const SupportLink = ({
  title,
  cta,
  href,
  icon,
  handleClick,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <div className={classes.icon}>{icon}</div>
      <div>
        <p className={classes.title}>{title}</p>
        <LinkWithChevron href={href || '#'} handleClick={handleClick}>
          {cta}
        </LinkWithChevron>
      </div>
    </div>
  );
};

export default compose(React.memo)(SupportLink);
